<template>
  <div
    class="bg-opacity-40 fixed inset-0 z-[9999] flex items-center justify-center p-4"
    :class="mode === 'dark' ? 'bg-white-100 block' : 'bg-black-100'"
  >
    <div
      class="max-w-4xl rounded-xl w-full mx-auto"
      :class="mode === 'dark' ? 'bg-dark-70' : 'bg-white-100'"
    >
      <div
        class="flex items-center justify-between p-4 border-b"
        :class="mode === 'dark' ? 'border-dark-50' : ''"
      >
        <h5 class="font-medium text-[17px] leading-none">Scores</h5>
        <X
          :size="22"
          :stroke-width="1.75"
          @click="$emit('on-close', false)"
          class="cursor-pointer"
        />
      </div>
      <div
        class="without-scrollbar max-h-modal overflow-y-auto p-4 rounded-bl-xl rounded-br-xl"
        :class="mode === 'dark' ? 'bg-dark-70' : 'bg-gray-20 bg-opacity-30'"
      >
        <div class="grid grid-cols-3 gap-4">
          <div
            class="border rounded-lg flex items-center justify-between p-3"
            :class="
              mode === 'dark' ? 'bg-dark-70 border-dark-50' : 'bg-white-100'
            "
          >
            <div class="text-[15px] font-medium">Predictable</div>
            <div class="flex items-center gap-2">
              <CurrCompData
                :curr="Number(score?.prob.toFixed(2) ?? 0)"
                :best="0.71"
                :label="false"
                class="font-medium"
              />
            </div>
          </div>
          <div
            class="border rounded-lg flex items-center justify-between p-3"
            :class="
              mode === 'dark' ? 'bg-dark-70 border-dark-50' : 'bg-white-100'
            "
          >
            <div class="text-[15px] font-medium">Avg Predictability Length</div>
            <div class="flex items-center gap-2">
              <CurrCompData
                :curr="Number(score?.avg_topk_lengths.toFixed(2) ?? 0)"
                :best="4.1"
                :label="false"
                class="font-medium"
              />
            </div>
          </div>
          <div
            class="border rounded-lg flex items-center justify-between p-3"
            :class="
              mode === 'dark' ? 'bg-dark-70 border-dark-50' : 'bg-white-100'
            "
          >
            <div class="text-[15px] font-medium">
              Worst Predictability Length
            </div>
            <div class="flex items-center gap-2">
              <CurrCompData
                :curr="Number(score?.worst_topk_lengths.toFixed(2) ?? 0)"
                :best="22"
                :label="false"
                class="font-medium"
              />
            </div>
          </div>
        </div>
        <div class="mt-4 text-[15px]" v-if="aiResult">
          <h6 class="font-medium mb-2">
            <span
              class="inline-block"
              v-tooltip="{
                content: `<div style='max-width: 300px;'>This prediction is based off of writing style only, it can be a good way to break ties as to whether the content was AI generated but is easy to fool alone. </div>`,
                html: true,
                distance: 10,
              }"
              >Predictable Writing Style Detector</span
            >
          </h6>
          <div>
            {{ aiResult }}
          </div>
          <p class="mt-2">
            NOTE: If your writing is predictable and boring, this might be an
            issue for more than just Google
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { X } from "lucide-vue-next";
import CurrCompData from "../../components/ce/CurrCompData.vue";
import { useUserStore } from "../../stores/user";
export default {
  name: "AnalyzeScoreModal",
  setup() {
    const userStore = useUserStore();
    return {
      userStore,
    };
  },
  components: {
    CurrCompData,
    X,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    score: {
      type: Object,
      default: () => ({}),
    },
    mode: {
      type: String,
    },
  },
  computed: {
    aiResult() {
      return this.userStore.aiDetectionResult;
    },
  },
};
</script>
